import { useEffect } from 'react';
import { getOAuthCallbackParams } from '@/utils/oauthCallbackParams';

export const FIGMA_OAUTH_CALLBACK_CHANNEL = 'weave-figma-oauth-callback';
export const FIGMA_OAUTH_CALLBACK_MESSAGE_TYPE = 'WEAVE_FIGMA_OAUTH_CALLBACK';

export type FigmaOAuthCallbackMessage = {
  type: typeof FIGMA_OAUTH_CALLBACK_MESSAGE_TYPE;
  code: string | null;
  state: string | null;
  error: string | null;
};

/** Receives figma.com's OAuth redirect in the popup; relays the code to the opener and closes. */
export default function FigmaOAuthCallback() {
  useEffect(() => {
    const params = getOAuthCallbackParams();
    const message: FigmaOAuthCallbackMessage = {
      type: FIGMA_OAUTH_CALLBACK_MESSAGE_TYPE,
      code: params.code,
      state: params.state,
      error: params.error,
    };
    try {
      const channel = new BroadcastChannel(FIGMA_OAUTH_CALLBACK_CHANNEL);
      channel.postMessage(message);
      channel.close();
    } catch {
      // BroadcastChannel unavailable — best effort
    }
    window.close();
  }, []);

  return null;
}
